<template>
  <!-- <v-layout align-center>
    <v-flex sm8> -->
      <validation-provider v-slot="{errors}"
                           :vid="$attrs.vid"
                           :name="$attrs.vname"
                           :mode="mode"
                           :rules="rules"
                           :class="noAttach?'':'menu-has-id'"
                           :id="$attrs.vid"
                           :bails="bails">
        <v-combobox v-model="innerValue"
                      ref="innerValueId"
                      :error-messages="resolveErrorMessagesHidden(errors)"
                      :error="errors.length > 0"
                      :id="$attrs.vid"
                      v-bind="$attrs"
                      hide-no-data
                      outline
                      :attach="noAttach ? false : `#${$attrs.vid}` "
                      @input.native="updateTargetInput"
                      :dont-fill-mask-blanks="true"
                      :validate-on-blur="true"
                      :return-object="returnObject"
                      v-on="$listeners"></v-combobox>
      </validation-provider>
    <!-- </v-flex>
  </v-layout> -->
</template>
<script>
import BaseInputValidate from './BaseInputValidate'
export default {
  name: 'b-combobox',
  extends: BaseInputValidate,
  props: {
    returnObject: {
      type: Boolean,
      default: true
    },
    noAttach: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    updateTargetInput (e) {
      if (e.target && e.target.value) {
        this.innerValue = e.target.value
      }
    }
  },
  watch: {
  }
}
</script>
